import { analytics } from '@/utils/analytics';
import { id } from '@luminovo/commons';
import { QuoteImporterSupplierPortal } from '@luminovo/offers';
import React from 'react';
import { UrlParams } from '../../../../utils/routes';

export default function QuoteImporterSupplierPortalPage({
    pathParams,
    queryParams,
}: UrlParams<'/supplier-portal/quote-requests/:quoteRequestId/import'>) {
    const { quoteRequestId } = pathParams;
    const { returnTo } = queryParams;

    React.useEffect(() => {
        analytics.track(id('pdf-offer-importer/start'), {
            variant: 'supplier-portal',
        });
    }, []);

    return (
        <QuoteImporterSupplierPortal
            quoteRequestId={quoteRequestId}
            returnTo={returnTo}
            onSuccess={() => {
                analytics.track(id('pdf-offer-importer/success'), {
                    variant: 'supplier-portal',
                });
            }}
            onError={() => {
                analytics.track(id('pdf-offer-importer/error'), {
                    variant: 'supplier-portal',
                });
            }}
        />
    );
}
